.QuickSearchButton {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-width: 0;
    max-width: 640px;
    height: 40px;
    margin: 0;
    padding: 0 10px 0 12px;
    border: 1px solid var(--soniq-t--global--border--color--input--default);
    border-radius: 12px;
    background: var(--soniq-t--global--background--color--surface--input);
    color: var(--soniq-t--global--text--color--primary--default);
    font: inherit;
    text-align: left;
    cursor: pointer;
    transition: background 150ms ease, border-color 150ms ease;

    &:hover {
        background: var(--soniq-t--global--background--color--surface--hover);
        border-color: var(--soniq-t--global--border--color--emphasis--default);
    }

    &:active {
        background: var(--soniq-t--global--background--color--surface--hover);
        border-color: var(--soniq-t--global--palette--hot-pink);
    }

    &:focus-visible {
        outline: var(--soniq-t--global--focus-ring--width) solid var(--soniq-t--global--focus-ring--color);
        outline-offset: var(--soniq-t--global--focus-ring--offset);
    }
}

.QuickSearchButton__icon {
    flex: 0 0 auto;
    color: var(--soniq-t--global--text--color--hint--default);

    &:global(.MuiSvgIcon-root) {
        font-size: 20px;
    }
}

.QuickSearchButton__label {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 16px;
    font-weight: var(--soniq-t--global--font--weight--medium);
    color: var(--soniq-t--global--text--color--primary--default);

    &.isPlaceholder {
        font-weight: var(--soniq-t--global--font--weight--regular);
        color: var(--soniq-t--global--text--color--hint--default);
    }
}

.QuickSearchButton__kbd {
    display: inline-flex;
    flex: 0 0 auto;
}

@media (prefers-reduced-motion: reduce) {
    .QuickSearchButton {
        transition: none;
    }
}
